import onetime from "@-/com.npmjs.onetime";
import type { AnalyticsPropertyValue } from "#analytics-event";

/** In-memory properties merged into every event this runtime captures (not persisted). */
export type AnalyticsContext = {
  /** The study interval in progress, so each review can be attributed to its session. */
  study_session_id?: string;
};

const getContextState = onetime((): { context: AnalyticsContext } => ({ context: {} }));

export function getAnalyticsContext(): Record<string, AnalyticsPropertyValue> {
  return getContextState().context;
}

/** Merges `patch`; an `undefined` value removes that key. */
export function setAnalyticsContext(patch: Partial<Record<keyof AnalyticsContext, string | undefined>>) {
  const state = getContextState();
  const next: Record<string, string> = { ...state.context };
  for (const [key, value] of Object.entries(patch)) {
    if (value === undefined) {
      delete next[key];
    } else {
      next[key] = value;
    }
  }
  state.context = next;
}
